<template>
	<div v-if="authed">
		<v-data-table :headers="headers" :items="items" item-key="_id"
			:options.sync="options" :server-items-length="totalItems"
			:loading="loading" loading-text="加载中...">
			<template v-slot:item.actions="{ item }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn v-bind="attrs" v-on="on" fab x-small class="ml-2" color="primary" outlined @click.stop="remove(item._id)">
							<v-icon>mdi-trash-can-outline</v-icon>
						</v-btn>
					</template>
					<span>删除</span>
				</v-tooltip>
			</template>
			<template v-slot:item.blocktime="{ item }">
				{{formatTime(item.blocktime)}}
			</template>
			<template v-slot:footer.prepend>
				<div class="pt-3" style="float:left">
					<v-icon large @click.stop="addItem">mdi-plus</v-icon>
				</div>
			</template>
		</v-data-table>
        <v-dialog persistent eager v-model="dialog" max-width="500" :loading="loading">
			<v-card>
				<template slot="progress">
					<v-progress-linear absolute	color="primary"	height="4" indeterminate/>
				</template>		
				<v-card-title>黑名单</v-card-title>
				<v-card-text>
					<v-form ref="form" class="px-4">
						<v-row>
						<v-col><v-text-field label="证件号" v-model.trim="idcard" append-icon="search" @click:append="search" @keyup.enter.native="search"/></v-col>
						<v-col><v-text-field label="姓名" dense :value="username" readonly filled/></v-col>
						</v-row>
						<v-textarea label="拉黑原因" v-model.trim="comment" outlined/>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" @click.stop="saveItem" :loading="loading" :disabled="loading||!username">保存</v-btn>
					<v-btn @click.stop="dialog = false">取消</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
	<div v-else>
		无此权限
	</div>
</template>

<script>
	import {formatTime} from '../utils'

	export default {
		data() {
			return {
				authed: false,
				headers: [
					{text:'操作', value:'actions', width:40, sortable: false, cellClass:'pl-1 pr-0'},
					{text:'姓名', value:'username', width:100},
					{text:'证件号', value:'idcard', width:150},
					{text:'拉黑原因', value:'comment', width:320},
					{text:'拉黑时间', value:'blocktime', width:120},
					{text:'操作者', value:'operator', width:100},
				],
                items: [],
				loading: false,
				options: {},
				totalItems: 0,
				dialog: false,
				idcard: null,
				username: null,
				comment: null,
			}
		},
		created() {
			this.formatTime = formatTime;
		},
		mounted() {
			this.authed = this.$hasPrivilege(['黑名单']);
			if (!this.authed) return;
		},
		methods: {
			async loadData() {
				if (this.options.page !== 1) {
					this.options.page = 1;	//自动触发fetchData
					return;
				}
				await this.fetchData();
			},
			async fetchData() {
				const db = this.$tcbapp.database();
				const _ = db.command;
				this.loading = true;
				try {
                    const countRes = await db.collection('blacklist').count();
					this.totalItems = countRes.total;
					const { sortBy, sortDesc, page, itemsPerPage } = this.options;
					const res = await db.collection('blacklist').orderBy(sortBy[0]||'_', sortDesc[0] ? 'desc' : 'asc')
						.skip((page-1) * itemsPerPage).limit(itemsPerPage)
						.get();
					this.items = res.data;
				} catch(err) {
					console.error(err);
				}
				this.loading = false;
			},
			async addItem() {
				this.idcard = null;
				this.username = null;
				this.dialog = true;
				this.$nextTick(()=>this.$refs.form.resetValidation());
			},
			async saveItem() {
				if (!this.idcard || !this.username) return;
				this.loading = true;
				try {
					const r = await this.$tcbapp.callFunction({name:"wp2mp", data:{funcname:'saveBlacklist',
						data: {
							idcard: this.idcard,
							username: this.username,
							comment: this.comment,
						}
					}});
					this.dialog = false;
					await this.fetchData();
				} catch(err) {
					console.error(err);
				}
				this.loading = false;
			},
			async remove(_id) {
				const res = await this.$dialog.warning({
					text: '确定要删除此项？',
					title: '提示'
				});
				if (!res) return;
				this.loading = true;
				try {
					const res = await this.$callCloudFunc({
						funcname:'removeBlacklist',
						data: {
							_id,
						}
					});
					await this.fetchData();
				} catch(err) {
					console.error(err);
					this.$dialog.message.error('删除失败');
				} finally {
					this.loading = false;
				}
			},
			async search() {
				if (!this.idcard) return;
				const db = this.$tcbapp.database();
				const _ = db.command;
				this.loading = true;
				try {
					const res = await db.collection('wp2order').where({'pii.idcard':this.idcard}).get();
					if (res.data.length > 0) {
						this.username = res.data[0].pii.username;
					} else {
						this.$dialog.message.error("未查询到此证件号");
					}
				} catch(err) {
					console.error(err);
				}
				this.loading = false;
			},
		},
		watch: {
			options: {
				handler () {
					this.fetchData()
				},
				deep: true,
			},
		},
	}
</script>
